import { CSSObject, DefaultTheme } from "styled-components";
import { useTheme } from "../../VFX-UI/Theme/ThemeProvider";
import { vfxTheme } from "../../VFX-UI/Theme/theme";

interface FormHeaderStyles {
    container: CSSObject;
    label: CSSObject;
    buttonContainer: CSSObject;
    title: CSSObject;
    subTitle: CSSObject;
    titleContainer: CSSObject;
    chip: CSSObject;
}

const useFormHeaderStyles = (): FormHeaderStyles => {
    
    return {
        container: {
            marginBottom: vfxTheme.spaceUnits.sp04,
        },
        label: {
            fontWeight: vfxTheme.fontWeights.semiBold,
            marginBottom: 0,
            marginRight: vfxTheme.spaceUnits.sp01,
        },
        buttonContainer: {
            display: "flex",
            justifyContent: "end",
        },
        titleContainer: {
            display: "flex",
            alignItems: "center",
        },
        title: {
            fontWeight: vfxTheme.fontWeights.semiBold,
            marginBottom: 0,
            marginRight: vfxTheme.spaceUnits.sp01,
            fontSize: "1.5em"
        },
        subTitle: {
            fontWeight: vfxTheme.fontWeights.light,
            marginBottom: 0,
            marginRight: vfxTheme.spaceUnits.sp01,
            fontSize: "1em",
            fontStyle: "italic"
        },
        chip: {
            marginBottom:"auto"
        },
    };
};

export default useFormHeaderStyles;
